import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AdminLayout from "./AdminLayout";
import PrivateRoute from "./PrivateRoute";
import constants from "../common/constants";

const Dashboard = LazyLoad(lazy(() => import("../pages/dashboard")));
const UserOnly = LazyLoad(lazy(() => import("../pages/user")));
const { ADMIN, USER } = constants;

const AdminRoutes = {
  path: "/app",
  element: <AdminLayout />,
  children: [
    {
      path: "/app",
      element: (
        <PrivateRoute element={<Dashboard />} requiredRole={[ADMIN, USER]} />
      ),
    },

    {
      path: "users",
      element: <PrivateRoute element={<UserOnly />} requiredRole={[ADMIN]} />,
    },

    {
      path: "/app/user-only",
      element: <PrivateRoute element={<UserOnly />} requiredRole={[USER]} />,
    },
  ],
};

export default AdminRoutes;
